import { render, staticRenderFns } from "./Bstore.vue?vue&type=template&id=322cac14&scoped=true&"
import script from "./Bstore.vue?vue&type=script&lang=js&"
export * from "./Bstore.vue?vue&type=script&lang=js&"
import style0 from "./Bstore.vue?vue&type=style&index=0&id=322cac14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cac14",
  null
  
)

export default component.exports